import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Role } from '@/types';

interface RoleState {
  roles: Role[];
}

const initialState: RoleState = { roles: [] };

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setRoles(state, action: PayloadAction<Role[]>) {
      state.roles = action.payload;
    },
    addRole(state, action: PayloadAction<Role>) {
      state.roles.push(action.payload);
    },
    removeRole(state, action: PayloadAction<Role>) {
      state.roles = state.roles.filter((r) => r.id !== action.payload.id);
    },
    editRole(state, action: PayloadAction<Role>) {
      const i = state.roles.findIndex((r) => r.id === action.payload.id);
      if (i !== -1) state.roles[i] = action.payload;
    },
  },
});

export const { setRoles, addRole, removeRole, editRole } = roleSlice.actions;
export default roleSlice.reducer;
